/**
 * Lookup and return the human-friendly label for a given Facet option key.
 * e.g. "stageEarlyChildhood" would return; "Early Childhood"
 *
 * @param {String} optionKey The key to lookup the value for
 * @param {Boolean} usePlural Return the pluralised version of the label
 *
 * @returns String
 */
export const getFacetOptionLabelByKey = (optionKey, usePlural = false) => {
    let optionLabel = '';

    switch (optionKey) {
        case 'typeLessonPlan':
            if (usePlural) {
                optionLabel = 'Lesson Plans';
            } else {
                optionLabel = 'Lesson Plan';
            }
            break;

        case 'typeProgram':
            if (usePlural) {
                optionLabel = 'Programs';
            } else {
                optionLabel = 'Program';
            }
            break;

        case 'typePolicy':
            if (usePlural) {
                optionLabel = 'Policies';
            } else {
                optionLabel = 'Policy';
            }
            break;

        case 'typeAdditionalResource':
            if (usePlural) {
                optionLabel = 'Additional Resources';
            } else {
                optionLabel = 'Additional Resource';
            }
            break;

        case 'curriculumHealthPE':
            optionLabel = 'Health and PE';
            break;

        case 'curriculumEnglish':
            optionLabel = 'English';
            break;

        case 'curriculumMaths':
            optionLabel = 'Maths';
            break;

        case 'curriculumTechnology':
            optionLabel = 'Technology';
            break;

        case 'curriculumScience':
            optionLabel = 'Science';
            break;

        case 'curriculumBiologicalScience':
            optionLabel = 'Biological Science';
            break;

        case 'curriculumScienceHumanEndeavour':
            optionLabel = 'Science as a Human Endeavour';
            break;

        case 'curriculumMedia':
            optionLabel = 'Media';
            break;

        case 'curriculumHumanities':
            optionLabel = 'Humanities';
            break;

        case 'curriculumGeography':
            optionLabel = 'Geography';
            break;

        case 'curriculumBabyAtHome':
            optionLabel = 'Baby At Home';
            break;

        case 'curriculumChildcare':
            optionLabel = 'Childcare';
            break;

        case 'curriculumKindergartenPreschool':
            optionLabel = 'Kindergarten/Preschool';
            break;

        case 'stageEarlyChildhood':
            optionLabel = 'Early Childhood';
            break;

        case 'stagePrimarySchool':
            optionLabel = 'Primary School';
            break;

        case 'stageSecondarySchool':
            optionLabel = 'Secondary School';
            break;

        case 'stageTertiaryEducation':
            optionLabel = 'Tertiary Education';
            break;

        case 'stageLearnerNoviceDriver':
            optionLabel = 'Learner/Novice Driver';
            break;

        case 'gradePrep':
            optionLabel = 'Prep';
            break;

        case 'gradeYear1':
            optionLabel = 'Year 1';
            break;

        case 'gradeYear2':
            optionLabel = 'Year 2';
            break;

        case 'gradeYear3':
            optionLabel = 'Year 3';
            break;

        case 'gradeYear4':
            optionLabel = 'Year 4';
            break;

        case 'gradeYear5':
            optionLabel = 'Year 5';
            break;

        case 'gradeYear6':
            optionLabel = 'Year 6';
            break;

        case 'gradeYear7':
            optionLabel = 'Year 7';
            break;

        case 'gradeYear8':
            optionLabel = 'Year 8';
            break;

        case 'gradeYear9':
            optionLabel = 'Year 9';
            break;

        case 'gradeYear10':
            optionLabel = 'Year 10';
            break;

        case 'gradeYear11':
            optionLabel = 'Year 11';
            break;

        case 'gradeYear12':
            optionLabel = 'Year 12';
            break;

        case 'gradeVCAL':
            optionLabel = 'VCAL';
            break;

        case 'learningModeIncursion':
            optionLabel = 'Incursion';
            break;

        case 'learningModeExcursion':
            optionLabel = 'Excursion';
            break;

        case 'learningModeInClass':
            optionLabel = 'In-Class';
            break;

        case 'learningModeSelfLearning':
            optionLabel = 'Self Learning';
            break;

        case 'learningModeInteractiveLearning':
            optionLabel = 'Interactive Learning';
            break;

        case 'learningModeAtHome':
            optionLabel = 'At-Home';
            break;

        case 'learningModeOnline':
            optionLabel = 'Online';
            break;

        default:
            optionLabel = `Error: No label found for key: ${optionKey}`;
            break;
    }

    return optionLabel;
};

/**
 * Check through a given query string and return all values that match a provided key.
 *
 * @param {String} queryString The full query string (or URL). e.g. id=1234&src=home&campaign-ID=r569_WW&f.Type|type=abc&f.Type|type=xyz
 * @param {String} key The key of the options to be matched. e.g. f.Type|type
 *
 * @returns Array of matched values
 */
export const getQueryParameterValuesByKey = (queryString, key) => {
    const queryKeyValues = [];
    let allQueryParameters = [];
    let currentParameter = [];
    let escapedQueryKey = '';
    let valueTest = {};

    // Split all the query values into an Array
    allQueryParameters = queryString.split('&');

    // Escape any special characters in the query key
    escapedQueryKey = key
        .replace(/\./g, '\\.')
        .replace(/\|/g, '%7C')
        .replace(/\+/g, '\\+');

    // Assemble the RegExp
    valueTest = new RegExp(`(?=^|&)${escapedQueryKey}=(.*?)(?=&|$)`);

    // Check all the parameters for a key match and extract the value
    for (let i = 0, j = allQueryParameters.length; i < j; ++i) {
        currentParameter = allQueryParameters[i].match(valueTest);

        if (currentParameter !== null) {
            queryKeyValues.push(currentParameter[1]);
        }
    }

    return queryKeyValues;
};
